import React from 'react';
import { Card, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { ASSET_URL } from './../../constant';
import { FaTrash } from 'react-icons/fa';

const CardWishlist = (props) => {

    const mainImage = JSON.parse(props.data.image);

    return (
        <Col lg={3} md={6} sm={12} className="my-4">
            <Card className="border rounded-0 product-wishlist position-relative">
                <div className="delete-wishlist-btn" onClick={() => props.delete(props.data.wishlist_id)} >
                    <FaTrash className="fs-5 text-white" />
                </div>
                <Link to={'/products/'+ props.data.item_no} className="text-dark">
                    <Card.Body>
                        <div className="product-image">
                            <Card.Img variant="top" src={ASSET_URL + mainImage[0].url} className="rounded-0" alt="" />
                        </div>
                        <div className="product-detail">
                            <div className="product-name">
                                <p className="fs-5 m-0 fw-bold text-uppercase">{props.data.name}</p>
                            </div>
                            <div className="product-desc" dangerouslySetInnerHTML={{__html: props.data.description}} />
                            <div className="product-item">
                                <p className="text-secondary">MI ITEM # {props.data.item_no}</p>
                            </div>
                        </div>
                    </Card.Body>
                </Link>
            </Card>
        </Col>
    )
}

export default CardWishlist
